import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Row } from '@tanstack/react-table';
import { FormattedMessage } from 'react-intl';

import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { WebhookEndpoint } from 'src/features/webhook-endpoints/utils/types';
import DeleteWebhookEndpointFormModal from 'src/features/webhook-endpoints/components/forms/DeleteWebhookEndpointFormModal';
import UpdateWebhookEndpointFormModal from 'src/features/webhook-endpoints/components/forms/UpdateWebhookEndpointFormModal';
import RotateWebhookEndpointSecretModal from 'src/features/webhook-endpoints/components/forms/RotateWebhookEndpointSecretModal';
import { webhookEndpointsMessages } from 'src/features/webhook-endpoints/utils/messages';

type CellWebhookEndpointActionsProps = {
    row: Row<WebhookEndpoint>;
};

export default function CellWebhookEndpointActions({ row }: CellWebhookEndpointActionsProps) {
    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <RotateWebhookEndpointSecretModal selectedWebhookEndpoint={row.original}>
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.ROTATE} />
                            </Button>
                        </TooltipTrigger>
                    </RotateWebhookEndpointSecretModal>
                    <TooltipContent>
                        <FormattedMessage {...webhookEndpointsMessages.rotateSecret} />
                    </TooltipContent>
                </Tooltip>
                <Tooltip>
                    <UpdateWebhookEndpointFormModal selectedWebhookEndpoint={row.original}>
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                            </Button>
                        </TooltipTrigger>
                    </UpdateWebhookEndpointFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.edit} />
                    </TooltipContent>
                </Tooltip>
                <Tooltip>
                    <DeleteWebhookEndpointFormModal selectedWebhookEndpoint={row.original}>
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                            </Button>
                        </TooltipTrigger>
                    </DeleteWebhookEndpointFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.delete} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
